import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';

import { MergeAttributes } from '../FlatData';

import ActingForm from './ActingForm';
import ActingTable from './ActingTable';
import ActorTable from './ActorTable';

class Form extends Component {
  constructor(){
    super();

    this.state = {
      id: null,
      acting: {},
      start_at: moment().add(543, 'years').format('L'),
      end_at: moment().add(543, 'years').format('L'),
      actors: [],
      showForm: true,
      showActingTable: false,
      showActorTable: false
    }

    this.openForm = this.openForm.bind(this);
    this.openActingTable = this.openActingTable.bind(this);
    this.openActorTable = this.openActorTable.bind(this);
    this.handleSelectActing = this.handleSelectActing.bind(this);
    this.handleSelectActor = this.handleSelectActor.bind(this);
    this.removeSelected = this.removeSelected.bind(this);
    this.changeStartAt = this.changeStartAt.bind(this);
    this.changeEndAt = this.changeEndAt.bind(this);
    this.updateActorMessage = this.updateActorMessage.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    let nextActing = nextProps.acting;

    if (nextActing.id && this.state.id !== nextActing.id) {
      let start_at = moment.utc(nextActing.start_at, "DD/MM/YYYY").format('L');
      let end_at = moment.utc(nextActing.end_at, "DD/MM/YYYY").format('L');

      if(nextActing.start_at.match("29/02/2567")){
        start_at = "29/02/2567"
      }
      if(nextActing.end_at.match("29/02/2567")){
        end_at = "29/02/2567"
      }

      let actors = nextActing.actors.map(actor => {
        return(
          {
            positions_user_id: _.get(actor, "attributes.positions_user.id"),
            message: actor.attributes.message
          }
        )
      });

      this.setState({
        id: nextActing.id,
        acting: {
          positions_user_id: nextActing.positions_user.id
        },
        start_at: start_at,
        end_at: end_at,
        actors: actors,
        showForm: true,
        showActingTable: false,
        showActorTable: false
      });
    } else {
      let start_at = moment().add(543, 'years').format('L');
      let end_at = moment().add(543, 'years').format('L');

      this.setState({
        id: null,
        acting: {},
        start_at: start_at,
        end_at: end_at,
        actors: [],
        showForm: true,
        showActingTable: false,
        showActorTable: false
      })
    }
  }
  
  openForm(){
    this.setState({
      showForm: true,
      showActingTable: false,
      showActorTable: false
    })
  }
  
  openActingTable(){
    this.setState({
      showForm: false,
      showActingTable: true,
      showActorTable: false
    })
  }
  
  openActorTable(){
    this.setState({
      showForm: false,
      showActingTable: false,
      showActorTable: true
    })
  }

  handleSelectActing(row, isSelected, e){
    this.setState({
      acting: {
        positions_user_id: row.id
      }
    });

    this.openForm();
  }

  handleSelectActor(row, isSelected, e){
    let actors = [...this.state.actors];
    let isIncluded = _.find(actors, {positions_user_id: row.id});
    let message = "";
    const actingPositionsUser = _.find(this.props.positions_users, { id: this.state.acting.positions_user_id })
    
    if(actingPositionsUser){
      message = `${row.position_name}\nรักษาราชการแทน ${actingPositionsUser.position_name}`
    }

    if(isIncluded === undefined){
      this.setState({
        actors: [
          ...this.state.actors, 
          {
            positions_user_id: row.id,
            message: message
          }
        ]
      });
    }

    this.openForm();
  }

  removeSelected(positions_user_id){
    this.setState({
      actors: _.reject(this.state.actors, { positions_user_id: positions_user_id })
    })
  }

  changeStartAt(event){
    this.setState({
      start_at: event.target.value
    });
  }

  changeEndAt(event){
    this.setState({
      end_at: event.target.value
    });
  }

  updateActorMessage(positions_user_id, event){
    var newActors = this.state.actors;
    var actor = _.find(newActors, {positions_user_id: positions_user_id});
    actor.message = event.target.value;

    this.setState({
      actors: newActors
    });
  }

  handleSubmit(){
    console.log("this.state.acting", this.state.acting);

    this.props.onSubmit({
      id: this.state.id,
      acting: this.state.acting,
      start_at: this.state.start_at,
      end_at: this.state.end_at,
      actors: this.state.actors,
    });
  }

  handleRemove(){
    this.props.onRemove(this.state.id);
  }

  render(){
    const positions_users = MergeAttributes(this.props.positions_users);

    const positions_users_without_actor = _.filter(positions_users, function(pu) {
                                            return pu.is_actor == false
                                          });

    return(
      <form>
        {this.state.showForm && (
          <ActingForm positions_users={positions_users}
                      acting={this.state.acting}
                      start_at={this.state.start_at}
                      end_at={this.state.end_at}
                      actors={this.state.actors}
                      openActingTable={this.openActingTable}
                      openActorTable={this.openActorTable}
                      removeSelected={this.removeSelected}
                      changeStartAt={this.changeStartAt}
                      changeEndAt={this.changeEndAt}
                      updateActorMessage={this.updateActorMessage} />
        )}

        {this.state.showActingTable && (
          <ActingTable  positions_users={positions_users}
                        onSelectActing={this.handleSelectActing}
                        openForm={this.openForm} />
        )}

        {this.state.showActorTable && (
          <ActorTable positions_users={positions_users_without_actor}
                      onSelectActor={this.handleSelectActor}
                      openForm={this.openForm} />
        )}
        
        <div className="modal-footer col-12">
          <button type='button' className="btn btn-primary pointer" onClick={this.handleSubmit}>บันทึกข้อมูล</button>
          <button type='button' className="btn btn-secondary pointer" onClick={this.handleRemove}>ยกเลิกรักษาราชการแทน</button>
          <button type='button' className="btn btn-secondary pointer" onClick={this.props.onClose}>ยกเลิก</button>
        </div>
      </form>
    )
  }
}

export default Form;



// WEBPACK FOOTER //
// ./src/components/Acting/Form.js